export enum SequencesScreenNames {
  MAIN = 'sequences',
  SEQUENCE = 'sequence',
  SEQUENCE_FORMS = 'sequence_forms',
}
